export default "__VITE_ASSET___zHIFg3A__"